import { useState, useEffect } from "react"; 
import { jwtFetch } from "./utils/apiClient";
import { useParams, useNavigate } from "react-router-dom";
import { config } from "./Components/Config";
import Menu from "./Components/Menu";
import Header from "./Components/Header";

const CategoryEdit = () => {
  const { id_product_category } = useParams();
  const [ productCategoryName, setProductCategoryName ] = useState('');
  const [ productCategoryTerms, setProductCategoryTerms ] = useState('');
  const [ productCategoryStatus, setProductCategoryStatus ] = useState('Active');
  const [ isLoadingSubmit, setIsLoadingSubmit ] = useState(false);
  
  const navigate = useNavigate();

  useEffect(() => {
    getCategory();
  }, []);

  const getCategory = async () => {
    try {
      const requestCategory = {
        id_product_category: id_product_category
      };
      const fetchCategory = await jwtFetch(config.ENDPOINT + 'get/product_category', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestCategory)
      });
      const responseCategory = await fetchCategory.json();
      if (responseCategory.status === 200) {
        setProductCategoryName(responseCategory.data[0].product_category_name);
        setProductCategoryTerms(responseCategory.data[0].product_category_terms);
        setProductCategoryStatus(responseCategory.data[0].product_category_status);
      } else {
        alert(responseCategory.message);
      }
    } catch (error) {
      console.error('Error in getCategory:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  }

  const submitCategoryEdit = async (e) => {
    try {
      e.preventDefault();
      setIsLoadingSubmit(true);
      const requestCategoryEdit = {
        "id_product_category": id_product_category,
        "product_category_name": productCategoryName,
        "product_category_terms": productCategoryTerms,
        "product_category_status": productCategoryStatus,
      }
      const fetchCategoryEdit = await jwtFetch(config.ENDPOINT + 'update/product_category', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestCategoryEdit)
      });
      const responseCategoryEdit = await fetchCategoryEdit.json();
      if (responseCategoryEdit.status === 200) {
        window.location.href = '/product/category/detail/' + id_product_category;
      } else {
        alert(responseCategoryEdit.message);
        setIsLoadingSubmit(false);
      }
    } catch (error) {
      console.error('Error in submitCategoryEdit:', error);
      alert('An error occurred: ' + (error.message || error));
      setIsLoadingSubmit(false);
    }
  }

  return (
    <div id="category-edit">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="col-md-2 border-end">
            <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
              <a className="h-100" href="/dashboard"><img className="h-100" src="/cuancuan.png" alt="PointStar"/></a>
            </div>
            <hr className="m-0"/>
            <Menu active="product"/>
          </div>
          <div className="col-md-10">
            <Header/>
            <hr className="m-0"/>
            <div className="main">
              <div className="p-4">

                <section className="mb-4">
                  <div className="fs-24 mb-3"><button className="btn btn-link" onClick={() => navigate(-1)}><i className="bi bi-arrow-left"/></button> Category Edit</div>
                  <form className="row" onSubmit={(e) => submitCategoryEdit(e)}>
                    <div className="col-md-6">
                      <div className="row form-group align-items-center mb-2">
                        <div className="col-md-4">
                          <label>Name <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8">
                          <input className="form-control" type="text" value={productCategoryName} onChange={(e) => setProductCategoryName(e.target.value)} required/>
                        </div>
                      </div>
                      <div className="row form-group align-items-baseline mb-2">
                        <div className="col-md-4">
                          <label>Subscription Terms</label>
                        </div>
                        <div className="col-md-8">
                          <textarea className="form-control" rows="5" value={productCategoryTerms} onChange={(e) => setProductCategoryTerms(e.target.value)}/>
                        </div>
                      </div>
                      <div className="row form-group align-items-center mb-4">
                        <div className="col-md-4">
                          <label>Status <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8">
                          <div className="form-check form-switch pt-1">
                            <input id="user-active" className="form-check-input" type="checkbox" value="Active" onChange={() => setProductCategoryStatus(productCategoryStatus === 'Active' ? 'Inactive' : 'Active')} checked={productCategoryStatus === 'Active' ? true : false}/>
                            <label htmlFor="user-active" className="form-check-label">{productCategoryStatus}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="d-flex justify-content-end mb-4">
                        <button className="btn btn-sm btn-link text-danger" type="button" onClick={() => window.location.href = '/product/category/detail/' + id_product_category}>Cancel</button>
                        <button className="btn btn-sm btn-primary ms-2" type="submit" disabled={isLoadingSubmit}>{isLoadingSubmit ? 'Loading...' : 'Update'}</button>
                      </div>
                    </div>
                  </form>
                </section>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryEdit;

